import React from 'react';

const Button = ({ className, secondary, ...rest }) => (
  <button
    {...rest}
    css={[styles.button, secondary && styles.secondary]}
    className={className}
  />
);

export default Button;

const bg = '#222';
const bgHover = '#111';
const bgActive = '#000';

const styles = {
  button: {
    backgroundColor: bg,
    borderColor: bg,
    borderRadius: '1.5rem',
    borderStyle: 'solid',
    borderWidth: '3px',
    color: '#fff',
    cursor: 'pointer',
    fontSize: '1em',
    fontWeight: '600',
    outline: 0,
    padding: '.875rem 2.625rem',
    ':hover': {
      borderColor: bgHover,
      backgroundColor: bgHover,
      color: '#fff',
    },
    ':active': {
      backgroundColor: bgActive,
    },
  },
  secondary: {
    backgroundColor: 'transparent',
    color: bg,
  },
};



// WEBPACK FOOTER //
// ./src/components/Button.js